import React from 'react'
import {StyledMenu} from './ReportsMenu.styles'
import useTrigger, {TriggerProps} from 'modules/reports/hooks/trigger'

export type Props = {
  trigger: (props: TriggerProps) => React.ReactNode
  children: React.ReactNode
}

function ReportsMenu(props: Props) {
  const {renderTrigger, renderContent} = useTrigger()

  return (
    <>
      {renderTrigger(props.trigger)}

      {renderContent(({id, opened, anchorEl, close}) => (
        <StyledMenu id={id} open={opened} anchorEl={anchorEl} onClose={close}>
          {props.children}
        </StyledMenu>
      ))}
    </>
  )
}

export default ReportsMenu
